import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { Result } from 'redux/schemas/api';
import { FetchRolesParams } from 'redux/schemas/api/role';
import { Role, RolesNormalized } from 'redux/schemas/models/role';

/**
 * load existing course into redux from angularjs side
 */
export const loadRoles = createAction<RolesNormalized>('LOAD_ROLES');


async function fetchRole(params: FetchRolesParams) {
  const response = await axios.get<Result<Role[]>>(`/course_roles.json?institution_id=${params.institutionId}.json`);
  return response.data.result;
}
export const getRoles = createAsyncThunk(
  'FETCH_ROLES',
  fetchRole,
);
